.root {
  height: var(--header-height);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 20px;
  background: var(--color-surface);
  border-bottom: 1px solid var(--color-border);
  position: relative;
  z-index: 20;
}

.left {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.menuButton {
  display: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  color: var(--color-text);
  cursor: pointer;
  flex-shrink: 0;
}

.divider {
  width: 1px;
  height: 32px;
  background: var(--color-border);
  flex-shrink: 0;
}

.titleBlock {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.ministryLabel {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--color-text-tertiary);
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.productRow {
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
}

.productName {
  font-size: 17px;
  font-weight: 700;
  color: var(--color-brand-primary);
  letter-spacing: -0.01em;
  white-space: nowrap;
}

.productTagline {
  font-size: 12.5px;
  color: var(--color-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

@media (max-width: 900px) {
  .productTagline {
    display: none;
  }
}

@media (max-width: 720px) {
  .menuButton {
    display: inline-flex;
  }

  .ministryLabel {
    display: none;
  }
}
